import { partialInit } from "../util/partial-init";

export class BeatYourBrokerResultModel {  
  contentKey1: string;
  contentKey2: string;
  showContactRequest: boolean;
  displayQuote: boolean;
  hasCover: boolean;
  canBetter: boolean;
  currentPremium: number;
  savings: number;
  assuraPremium: number;
  

  constructor(data?: Partial<BeatYourBrokerResultModel>) {
    partialInit(this, data);
  }
}
